/**
 * Function type that returns a string, used for error message callbacks
 */

export function getTextByErrorCode(errorCode, args) {
  switch (errorCode) {
    case 401:
      return args.error401();
    case 403:
      return args.error403();
    case 500:
      return args.error500();
    default:
      return args.defaultError ? args.defaultError() : undefined;
  }
}
export default getTextByErrorCode;